import { defineStore } from 'pinia'

interface State {
  cachePages: string[]
}

export const useBaseStore = defineStore('my_costomer_base', {
  state: (): State => ({
    cachePages: []
  }),
  actions: {
    setCachePages(page: string) {
      const index = this.cachePages?.findIndex((c: string) => c === page)
      if (index === -1) {
        this.cachePages?.push(page)
      }
    },
    removeCachePages(page: string | any[]) {
      if (Array.isArray(page)) {
        this.cachePages = this.cachePages?.filter(
          (item: string) => !page.includes(item)
        )
      } else {
        const index = this.cachePages?.findIndex((c: string) => c === page)
        if (index !== -1) {
          this.cachePages?.splice(index, 1)
        }
      }
    }
  },
  persist: true
})
